import React, { useEffect, useState, useRef } from 'react';

export default function IconPin() {
  return (
    <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="7" cy="6.78595" rx="7" ry="6.78577" fill="#990D00" />
      <path d="M7.80552 17.3769C7.4059 17.9203 6.59391 17.9203 6.19428 17.3769L1.39985 10.8573L12.5999 10.8573L7.80552 17.3769Z" fill="#990D00" />
      <ellipse cx="6.99995" cy="6.78578" rx="2.8" ry="2.71431" fill="white" />
    </svg>
  )
}